import {
    analyticsRequestError
} from './adobe-analytics';
import {
    DATASET
} from './constants';

const isDeliveryLaterThanSwitch = (deliveryDate, switchDate) =>
    new Date(deliveryDate) > new Date(switchDate);

const onDeliveryChoiceClick = (deliveryDateInput, switchDate, modalButton) => {
    if (!isDeliveryLaterThanSwitch(deliveryDateInput.value, switchDate)) {
        return;
    }
    deliveryDateInput.checked = false;
    modalButton.click();
    analyticsRequestError('Delivery date and Switch date conflict');
};

const dateConflict = () => {
    const modalButton = document.querySelector(`[${DATASET}-date-modal]`);

    if (!modalButton) {
        return;
    }

    const selectedSwitchDate = modalButton.getAttribute(`${DATASET}-date`);
    const deliveryDateInputs = document.querySelectorAll(
        '[data-delivery-selection-id="delivery_selection_date-selection"] input[type="radio"]'
    );

    deliveryDateInputs.forEach(deliveryDateInput =>
        deliveryDateInput.addEventListener('click', () => {
            onDeliveryChoiceClick(deliveryDateInput, selectedSwitchDate, modalButton);
        })
    );

    const checkedDeliveryDateInput = [...deliveryDateInputs].find(input => input.selected === true);

    if (!checkedDeliveryDateInput) {
        return;
    }

    onDeliveryChoiceClick(checkedDeliveryDateInput, selectedSwitchDate, modalButton);
};

export default dateConflict;
